import React, { useState } from "react";
import * as Yup from "yup";
import { Formik, Field } from "formik";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import "../Style/NewCustomer.css";
import "../Style/CreateTask.css";
import MainSidebar from "../User/Mainsidebar";
import UserFooter from "../User/UserFooter";
import UserNavbar from "../User/UserNavbar";
import { path_url } from "../Config/config";
import TicketTable from "../User/components/TicketsTable";

const supportTicketSchema = Yup.object().shape({
  title: Yup.string().required("Required"),
  description: Yup.string().required("Required"),
});

export default function SupportTicket() {
  const navigate = useNavigate();
  const [hamburger, sethamburger] = useState(false);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);
  const [refreshTickets, setRefreshTickets] = useState(false);

  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };

  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };

  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);

  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800)
      return { width: "100%", left: "0rem" };
    else
      return {
        width: !hamburger && "-webkit-fill-available",
        left: !hamburger && "3.7rem",
      };
  };

  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };

  // Cancel — navigate back to the previous page, discarding unsaved changes.
  // Falls back to the dashboard if there is no previous page in history.
  const handleCancel = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate("/crm-dashboard");
    }
  };

  const Priority = [
    { value: "High" },
    { value: "Medium" },
    { value: "Low" },
    { value: "Critical" },
    { value: "Normal" },
    { value: "Emergency" },
    { value: "Deferred" },
  ];

  return (
    <div className="con1 d-flex">
      <div className="subcon1" style={handleclickonbutton1(hamburger)}>
        <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
      </div>
      <div className="subcon2" style={handleclickonbutton(hamburger)}>
        <UserNavbar
          hamburger={hamburger}
          sethamburger={sethamburger}
          handelRightMenuShow={handelRightMenuShow}
          handelShow={handelShow}
          isSearchShow={isSearchShow}
          handleScreenEnter={handleScreenEnter}
          handleScreenExit={handleScreenExit}
          fullScreen={fullScreen}
        />
        <div className="mt-2 min-vh-100">
          <Formik
            initialValues={{
              title: "",
              description: "",
              status: "Open",
              priority: "Medium",
              file: "",
            }}
            validationSchema={supportTicketSchema}
            onSubmit={async (values, { resetForm }) => {
              try {
                const token = localStorage.getItem("accessToken");
                const usercid = localStorage.getItem("userId");

                const payload = {
                  ...values,
                  userid: usercid,
                };

                const response = await axios.post(
                  `${path_url}/ticket`,
                  payload,
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                      "Content-Type": "application/json",
                    },
                  },
                );

                if (response.data.statusCodeValue === 200) {
                  toast.success("Ticket submitted successfully!");
                  resetForm();
                  setRefreshTickets((prev) => !prev);
                } else {
                  toast.error(response.data.body);
                }
              } catch (errors) {
                console.log(errors);
              }
            }}
          >
            {(formik) => (
              <form onSubmit={formik.handleSubmit}>
                <fieldset>
                  <div className="col-12 d-flex justify-content-center h-[500px]">
                    <div className="bg-white col-11 cont">
                      <div className="d-flex mb-4">
                        <div
                          style={{ color: "gray" }}
                          className="col-12 m-1 mt-2 rounded shadow-sm elevation-2 pt-1"
                        >
                          <p className="text-white p-1 m-0">
                            <strong>Support Ticket</strong>
                          </p>
                        </div>
                      </div>

                      <div className="d-flex flex-wrap ">
                        <div className="col-12 col-md-6 pl-0 pr-0">
                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 text-right">
                              <label
                                className="m-0 p-0"
                                style={{ fontSize: 15 }}
                              >
                                <strong>Title</strong>
                                <sup style={{ color: "red" }}>*</sup>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8 forms">
                              <input
                                type="text"
                                placeholder="Title"
                                name="title"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.title}
                              />
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 text-right">
                              <label
                                className="m-0 p-0"
                                style={{ fontSize: 15 }}
                              >
                                <strong>Description</strong>
                                <sup style={{ color: "red" }}>*</sup>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8 forms">
                              <input
                                type="text"
                                placeholder="Description"
                                name="description"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.description}
                              />
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 text-right">
                              <label
                                className="m-0 p-0"
                                style={{ fontSize: 15 }}
                              >
                                <strong>Status</strong>
                                <sup style={{ color: "red" }}>*</sup>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8 forms">
                              <input
                                type="text"
                                name="status"
                                value={formik.values.status}
                                disabled
                                className="input-field"
                              />
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 text-right">
                              <label
                                className="m-0 p-0"
                                style={{ fontSize: 15 }}
                              >
                                <strong>Priority</strong>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8">
                              <Field
                                as="select"
                                name="priority"
                                className="selectBox custom-select"
                              >
                                {/* <option value="">Medium</option> */}
                                {Priority.map((option) => (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.value}
                                  </option>
                                ))}
                              </Field>
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 text-right">
                              <label
                                className="m-0 p-0"
                                htmlFor="file"
                                style={{ fontSize: 15 }}
                              >
                                <strong>File</strong>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8">
                              <Field
                                name="file"
                                id="file"
                                type="file"
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-12 d-flex justify-content-between pt-4">
                            <div className="p-2">
                              <button
                                className="btn btn-sm btn-light border rounded border-gray"
                                type="button"
                                onClick={handleCancel}
                              >
                                Cancel
                              </button>
                            </div>
                            <div className="p-2">
                              <button
                                type="submit"
                                className="btn btn-sm border rounded border-gray btn-info"
                                style={{
                                  backgroundColor: "rgba(52, 58, 64, 255)",
                                }}
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </form>
            )}
          </Formik>

          <div className="m-4 bg-white p-3 shadow-lg mx-5 mb-4">
            <TicketTable refresh={refreshTickets} />
          </div>
        </div>

        <UserFooter />
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
}